<template>
 <div class="collection-slug__content">
   <div class="--left">
     <div class="loading-image">
       <div class="loading-skeleton"/>
     </div>
   </div>
   <div class="--right">
     <div class="loading-name loading-skeleton"/>
     <div class="loading-content loading-skeleton"/>
   </div>
 </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.loading-image {
  display: flex;
  width: 100%;
  border-radius: 20px;
  position: relative;
  overflow: hidden;

  & > * {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
  }
  &::after {
    content: "";
    float: left;
    padding-top: 55.6%;
  }
}
.loading-name {
  display: flex;
  width: 60%;
  height: 40px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;

  & > * {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
  }
}
.loading-content {
  display: flex;
  width: 100%;
  margin-top: 24px;
  height: 220px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;

  & > * {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
  }
}
</style>
